import { useState } from "react";
import {
    Container,
    Grid,
    AppBar,
    Tabs,
    Tab,
    Box,
    Typography,
} from "@material-ui/core";
import HomePage from "../../Home";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import ItemsPagar from "../ItemsPagar";
import ItemsPagados from "../ItemsPagados";
import ItemsUtilidad from "../ItemsUtilidad"
import InsertChartIcon from '@material-ui/icons/InsertChart';
import VCorte from "../CorteCaja/VCorte";
import HistoryIcon from '@material-ui/icons/History';
import VToggleDevolucion from "../VToggleDevolucion";
import VToggleFacturas from "../VToggleFacturas";
import VToggleExtras from "../VToogleExtras";
import { usePermiso } from "../../../hooks/usePermiso";
import { catRoles } from "../../../constant/catRoles";
import { useSelector } from "react-redux";
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}

const VFinanzas = () => {
    const { profile } = useSelector(store => store.logeo)
    const [value, setValue] = useState(0);
    const [permitidoCorteCaja] = usePermiso({ location: "FK_FINANZAS_CORTE_MOVIMIENTOS", initialValue: false })
    const [permitidoItemXPagar] = usePermiso({ location: "FK_FINANZAS_ITEMS_X_PAGAR", initialValue: false })
    const [permitidoItemPagado] = usePermiso({ location: "FK_FINANZAS_ITEMS_PAGADOS", initialValue: false })
    const [permitidoExtras] = usePermiso({ location: "FK_FINANZAS_ITEMS_EXTRAS", initialValue: false })
    const [permitidoDevoluciones] = usePermiso({ location: "FK_FINANZAS_ITEMS_DEVOLUCIONES", initialValue: false })
    const [permitidoFacturacion] = usePermiso({ location: "FK_FINANZAS_ITEMS_FACTURAS", initialValue: false })
    const [permitidoUtilidad] = usePermiso({ location: "FK_FINANZAS_ITEMS_UTILIDAD", initialValue: false })

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <HomePage>
            <Container>
                <Grid item xs={12}>
                    <h2>Finanzas</h2>
                </Grid>
                <Grid item xs={12}>
                    <AppBar position="static" color="secondary">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="on"
                            indicatorColor="primary"
                            aria-label="scrollable force tabs example"
                        >
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoCorteCaja) &&
                                <Tab
                                    label="Corte movimientos USD"
                                    icon={<AccountBalanceIcon />}
                                    {...a11yProps(0)}
                                    value={0}
                                />
                            }
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoItemXPagar) &&
                                <Tab
                                    label="Items por pagar"
                                    icon={<AccountBalanceIcon />}
                                    {...a11yProps(1)}
                                    value={1}
                                />
                            }
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoItemPagado) &&
                                <Tab
                                    label="Items pagados"
                                    icon={<InsertChartIcon />}
                                    {...a11yProps(2)}
                                    value={2}
                                />
                            }
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoExtras) &&
                                <Tab
                                    label="Items extras"
                                    icon={<AccountBalanceIcon />}
                                    {...a11yProps(3)}
                                    value={3}
                                />
                            }
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoDevoluciones) &&
                                <Tab
                                    label="Devolución"
                                    icon={<HistoryIcon />}
                                    {...a11yProps(4)}
                                    value={4}
                                />
                            }
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoFacturacion) &&
                                <Tab
                                    label="Facturas"
                                    icon={<HistoryIcon />}
                                    {...a11yProps(5)}
                                    value={5}
                                />
                            }
                            {
                                (profile.Rol?.Id === catRoles.ADMINISTRADOR
                                    || profile.Rol?.Id === catRoles.DEVELOPER
                                    || permitidoUtilidad) &&
                                <Tab
                                    label="Items utilidad"
                                    icon={<InsertChartIcon />}
                                    {...a11yProps(6)}
                                    value={6}
                                />
                            }
                        </Tabs>
                    </AppBar>
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoCorteCaja) &&
                        <TabPanel value={value} index={0}>
                            <VCorte />
                        </TabPanel>
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoItemXPagar) &&
                        <TabPanel value={value} index={1}>
                            <ItemsPagar />
                        </TabPanel>
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoItemPagado) &&
                        <TabPanel value={value} index={2}>
                            <ItemsPagados />
                        </TabPanel>
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoExtras) &&
                        <TabPanel value={value} index={3}>
                            <VToggleExtras />
                        </TabPanel>
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoDevoluciones) &&
                        <TabPanel value={value} index={4}>
                            <VToggleDevolucion />
                        </TabPanel>

                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoFacturacion) &&
                        <TabPanel value={value} index={5}>
                            <VToggleFacturas />
                        </TabPanel>
                    }
                    {
                        (profile.Rol?.Id === catRoles.ADMINISTRADOR
                            || profile.Rol?.Id === catRoles.DEVELOPER
                            || permitidoUtilidad) &&
                        <TabPanel value={value} index={6}>
                            <ItemsUtilidad />
                        </TabPanel>
                    }
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VFinanzas